// extracted by mini-css-extract-plugin
export default {"container":"CardPerformance_container__iX5tY","text":"CardPerformance_text__loo1I","wrapperText":"CardPerformance_wrapperText__ShrwN","groupText":"CardPerformance_groupText__ZKsFF"};